import { movies, type Movie } from "@/mocks/movies";

export { movies };
export type { Movie };

export function getMovieById(id: string): Movie | undefined {
  return movies.find((m) => m.id === id);
}

export function getMoviesByType(type: string): Movie[] {
  return movies.filter((m) => m.type === type);
}

export function getFeaturedMovies(): Movie[] {
  return movies.filter((m) => m.featured);
}

export function getLatestMovies(limit = 8): Movie[] {
  return [...movies].sort((a, b) => b.year - a.year).slice(0, limit);
}

export function getHotMovies(limit = 10): Movie[] {
  return [...movies].sort((a, b) => b.popularity - a.popularity).slice(0, limit);
}

export function getRelatedMovies(movie: Movie, limit = 6): Movie[] {
  const scored = movies
    .filter((m) => m.id !== movie.id)
    .map((m) => {
      let score = 0;
      if (m.type === movie.type) score += 2;
      score += m.genres.filter((g) => movie.genres.includes(g)).length * 3;
      score += m.tags.filter((t) => movie.tags.includes(t)).length * 2;
      score += m.region === movie.region ? 1 : 0;
      return { m, score };
    })
    .sort((a, b) => b.score - a.score);
  return scored.slice(0, limit).map((s) => s.m);
}

export function searchMovies(keyword: string): Movie[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return movies.filter(
    (m) =>
      m.title.toLowerCase().includes(q) ||
      m.synopsis.toLowerCase().includes(q) ||
      m.description.toLowerCase().includes(q) ||
      m.genres.some((g) => g.toLowerCase().includes(q)) ||
      m.tags.some((t) => t.toLowerCase().includes(q)) ||
      m.region.toLowerCase().includes(q)
  );
}

export interface FilterOptions {
  region: string;
  year: string;
  genre: string;
}

export function filterMovies(
  list: Movie[],
  { region, year, genre }: FilterOptions
): Movie[] {
  return list.filter((m) => {
    if (region !== "全部" && m.region !== region) return false;
    if (year !== "全部" && String(m.year) !== year) return false;
    if (genre !== "全部" && !m.genres.includes(genre)) return false;
    return true;
  });
}

export type SortKey = "latest" | "hot" | "rating";

export function sortMovies(list: Movie[], key: SortKey): Movie[] {
  const copy = [...list];
  if (key === "latest") return copy.sort((a, b) => b.year - a.year);
  if (key === "hot") return copy.sort((a, b) => b.popularity - a.popularity);
  return copy.sort((a, b) => b.rating - a.rating);
}

export function typeLabel(type: string): string {
  return type === "movie" ? "电影" : "电视剧";
}